import axios from "axios";
import { Dispatch } from "redux";
import Url from "../../../Url";
import { SecondOpinionTypeActionTypes } from "./ActionTypes";
import { SecondOpinionListResponse } from "./Model";
import {
  secondSecondOpinionTypeAPIResClearAction,
  secondSecondOpinionTypeErrorAction,
  secondSecondOpinionTypeLoadingAction,
  secondSecondOpinionTypeSuccessAction,
  secondSecondOpinionTypeAPIMsgAction,
} from "./Action";
import { headers } from "../../../components/Utility";
import { setupInterceptorsTo } from "../../Authentication/Interceptors";

let apiRes = {} as SecondOpinionListResponse;
export const patientSecondOpinionType = () => {
  return function (dispatch: Dispatch<SecondOpinionTypeActionTypes>) {
    dispatch(secondSecondOpinionTypeLoadingAction(true));
    setupInterceptorsTo(axios)
      .get(Url.baseUrl + `/secondopinionapp/api/secondopinion/second_opinion_option`, {
        headers: headers,
      })
      .then((res) => {
        apiRes = res.data;
        dispatch(secondSecondOpinionTypeLoadingAction(false));
        dispatch(
          secondSecondOpinionTypeSuccessAction(
            res.data,
            res.data.message !== undefined
              ? res.data.message
              : "Opinion type fetch successfully."
          )
        );
      })
      .catch((error) => {
        dispatch(secondSecondOpinionTypeLoadingAction(false));
        dispatch(
          secondSecondOpinionTypeErrorAction(
            {} as SecondOpinionListResponse,
            error.response.data !== undefined
              ? error.response.data.message !== undefined
                ? error.response.data.message
                : "Something went wrong"
              : "Something went wrong",
            error.status !== undefined ? error.response.data.status || 0 : 0
          )
        );
      });
  };
};

export const secondSecondOpinionTypeAPIResMsg = () => {
  return function (dispatch: Dispatch<SecondOpinionTypeActionTypes>) {
    dispatch(secondSecondOpinionTypeAPIMsgAction(apiRes as SecondOpinionListResponse, "", "", 0));
  };
};

export const clearsecondSecondOpinionTypeAPIRes = () => {
  return function (dispatch: Dispatch<SecondOpinionTypeActionTypes>) {
    dispatch(secondSecondOpinionTypeAPIResClearAction({} as SecondOpinionListResponse, "", "", 0));
  };
};
